// Copyright (c) 2021 Deere & Company

import t from 'tcomb';

const UserDealerDataRequest = t.struct({
    usersIds: t.Any,
    dealerAccounts: t.Any,
    userIdsWild: t.Any,
    dealerAccountsWild: t.Any,
}, {
    name: 'UserDealerDataRequest',
    strict: false,
});

export const getDefaultState = () => new UserDealerDataRequest({
    usersIds: null,
    dealerAccounts: null,
    userIdsWild: null,
    dealerAccountsWild: null,
});

export default UserDealerDataRequest;
